// mobile ready - with 18+, T and C
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { HashLink as Link } from 'react-router-hash-link';
import './Navbar.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { useHistory } from 'react-router-dom';
import { Menu, MenuItem, IconButton, Divider, Avatar, Dialog } from '@mui/material';
import { Person, Search } from '@mui/icons-material';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import styles from './LoginForm.module.css';
import { useLoginFormValidator } from './hooks/useLoginFormValidator';

import { Visibility, VisibilityOff } from '@mui/icons-material';
import { InputAdornment, FormControl, InputLabel, Select, FormControlLabel, Checkbox } from '@mui/material';
import { CircularProgress } from '@mui/material';





import {
  Box,
  Typography,
  TextField,
  Button,
  Link as MuiLink,
  DialogTitle,
  DialogContent
} from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "background.paper",
  borderRadius: 3,
  p: 4,
  boxShadow: 24,
};



// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { Link } from "react-router-dom";





const Navbar = ({ user, setUser, visible, setVisible, loggedIn, setLoggedIn }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true); // Controls hamburger visibility
  const [openLogin, setOpenLogin] = useState(false);
  const [openSignup, setOpenSignup] = useState(false);
  const [openForgot, setOpenForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [form, setForm] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    gender: '',
    mobile: '',
    dob: '',
  });
  const [loading, setLoading] = useState(false);

  const [signupErrors, setSignupErrors] = useState([]);
  const [loginErrors, setLoginErrors] = useState([]);
  const history = useHistory();
  const { errors, validateForm, onBlurField } = useLoginFormValidator(form);

  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const [profilePic, setProfilePic] = useState(null);
  const [profilePicPreview, setProfilePicPreview] = useState(null);

  const handleProfilePicChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setProfilePic(file);
    setProfilePicPreview(URL.createObjectURL(file));
  };


  // Toggle mobile menu
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  // Toggle search bar
  const handleSearchToggle = () => {
    setVisible(!visible);
    closeMobileMenu(); // Close mobile menu when search is toggled
  };

  // User menu handlers
  const handleProfClick = (event) => {
    setAnchorEl(event.currentTarget);
    closeMobileMenu();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Check screen size for hamburger menu visibility
  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(true); // Show hamburger on mobile
    } else {
      setButton(false); // Hide hamburger on desktop
    }
  };

  const [showPassword, setShowPassword] = React.useState(false);

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  useEffect(() => {
    showButton();
    window.addEventListener('resize', showButton);
    return () => window.removeEventListener('resize', showButton);
  }, []);

  // Login state from localStorage
  useEffect(() => {
    const storedLoggedIn = localStorage.getItem('loggedIn');
    const savedUser = localStorage.getItem('user');
    if (storedLoggedIn === 'true' && savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, [setUser]);


  // Form input handler
  const onUpdateField = (e) => {
    const field = e.target.name;
    const nextFormState = { ...form, [field]: e.target.value };
    setForm(nextFormState);
    if (errors[field].dirty) {
      validateForm({ form: nextFormState, errors, field });
    }
  };

  // Modal toggles
  const onOpenLoginModal = () => {
    setOpenLogin(true);
    closeMobileMenu();
  };
  const onOpenSignupModal = () => {
    setOpenSignup(true);
    closeMobileMenu();
  };
  const onOpenForgotModal = () => {
    setOpenForgot(true);
    closeMobileMenu();
  };
  const onCloseLoginModal = () => setOpenLogin(false);
  const onCloseSignupModal = () => setOpenSignup(false);
  const onCloseForgotModal = () => setOpenForgot(false);


  // Signup handler
  const handleSubmitSignup = async (event) => {
    event.preventDefault();
    const { isValid } = validateForm({ form, errors, forceTouchErrors: true });
    if (!isValid) {
      alert('Please fix the errors in the form before submitting.');
      return;
    }

    if (form.password !== form.confirmPassword) {
      alert('Passwords should match');
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("email", form.email);
    formData.append("password", form.password);
    formData.append("first_name", form.firstName);
    formData.append("last_name", form.lastName);
    formData.append("gender", parseInt(form.gender));
    formData.append("date_of_birth", form.dob);
    formData.append("mobile", form.mobile);
    formData.append("usertype", "client"); // 0 for client

    if (profilePic) {
      formData.append("profile_pic", profilePic);
    }
    // console.log('gender', parseInt(form.gender));

    const signUpUrl = process.env.REACT_APP_SERVER
      ? 'https://salonserver-k8m8.onrender.com/signup'
      : 'http://localhost:3001/signup';

    try {
      const response = await axios.post(signUpUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        const token = response.headers['authorization'];
        localStorage.setItem('token', token);
        localStorage.setItem('loggedIn', 'true');
        onCloseSignupModal();
        alert('Registration successful. Please login to continue');
        setLoggedIn(true);
        setLoading(false);
        // const emailData = {
        //   subject: 'Client Registration Success!',
        //   name: form.firstName,
        //   email: form.email,
        //   message: `Dear ${form.firstName},\nThank you for registering with GroomWell Services. Now you can login and choose from a large number of salons or services\nFor any queries please call Customer Care.\n\nTeam GroomWell`,
        // };

        // const contactsUrl = process.env.REACT_APP_SERVER
        //   ? 'https://salonserver-k8m8.onrender.com/contacts'
        //   : 'http://localhost:3001/contacts';

        // await axios.post(contactsUrl, emailData, {
        //   headers: { Authorization: `${token}` },
        // });
      }
    } catch (signupError) {
      const errors = signupError.response?.data?.status?.errors || ['Something went wrong. Please try again.'];
      setSignupErrors(errors);
      alert(errors.join(', '));
      onCloseSignupModal();
      setLoading(false);
    }
  };

  // Login handler
  const handleSubmitLogin = async (event) => {
    event.preventDefault();
    const { isValid } = validateForm({ form, errors, forceTouchErrors: true });
    // if (!isValid) return;

    const loginUrl = process.env.REACT_APP_SERVER
      ? 'https://salonserver-k8m8.onrender.com/login'
      : 'http://localhost:3001/login';
    setLoading(true);
    try {
      const response = await axios.post(loginUrl, {
        user: { email: form.email, password: form.password },
      });
      // console.log('login response', response);
      if (response.data.data.usertype === 'sprovider') {
        alert('It seems you are registered as Service Provider. To avail booking services, please register as Client or Call Customer Care');
        localStorage.removeItem('loggedIn');
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        return;
      }

      if (response.status === 200) {
        const userData = response.data.data;
        setUser(userData);
        localStorage.setItem('loggedIn', 'true');
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('token', response.headers['authorization']);
        onCloseLoginModal();
        setLoggedIn(true);
        setLoading(false);
        alert('Login successful');
        setClick(true);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        // console.log('login error', error);
        alert('Invalid email or password');
      }
      const errors = loginErrors.response?.data?.status?.errors || ['Something went wrong. Please try again.'];
      setLoginErrors(errors);

      alert(errors.join(', '));
      onCloseLoginModal();
      setLoading(false);
    }
  };

  // Forgot password handler
  const handleSubmitForgotPassword = async (event) => {
    event.preventDefault();
    const forgotUrl = process.env.REACT_APP_SERVER
      ? 'https://salonserver-k8m8.onrender.com/forgot_password'
      : 'http://localhost:3001/forgot_password';
    setLoading(true);
    try {
      const response = await fetch(forgotUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: forgotEmail }),
      });

      if (response.status === 200) {
        alert('Password reset link sent to your email');
        setOpenForgot(false);
        setLoading(false);
      } else {
        alert('We could not find this email in our system');
        setOpenForgot(false);
        setLoading(false);
      }
    } catch (error) {
      alert('Error sending reset link');
    }
  };

  // Logout handler
  const handleLogout = () => {
    const logoutUrl = process.env.REACT_APP_SERVER
      ? 'https://salonserver-k8m8.onrender.com/logout'
      : 'http://localhost:3001/logout';

    axios
      .delete(logoutUrl, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('token'),
        },
      })
      .then((response) => {
        setUser(null);
        localStorage.removeItem('loggedIn');
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        history.push('/');
        alert(response.data.message);
        setLoggedIn(false);
        setClick(false);
      })
      .catch((error) => {
        alert(error.response?.status === 401 ? 'Session expired. Please log in again.' : 'Logout failed');
        setUser(null);
        localStorage.removeItem('loggedIn');
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        history.push('/');
        setLoggedIn(false);
      });
  };

  return (
    <IconContext.Provider value={{ color: '#6e6767' }}>
      <nav className="navbar my-1">
        <div className="navbar-container container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <img
              src="assets/GroomWell-Emblem.png"
              alt="Logo"
              style={{ width: 40, height: 40 }}
            />
            <div style={{ display: 'block', flexDirection: 'column' }}>
              <p style={{ fontSize: 24, fontWeight: 900, color: '#9d55e6' }}>GroomWell</p>
              <p style={{ fontSize: 13, fontWeight: 600, color: '#9d55e6', marginTop: -8 }} > Connecting you to Style, Seamlessly</p>
            </div>
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            {click ? <FaTimes /> : <FaBars />}
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className="nav-item">
              <Link
                to="/"
                className="nav-links"
                style={{ backgroundColor: 'transparent', border: 'none', color: 'black' }}
                onClick={closeMobileMenu}
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/contact"
                className="nav-links"
                style={{ backgroundColor: 'transparent', border: 'none', color: 'black' }}
                onClick={closeMobileMenu}
              >
                Contact
              </Link>
            </li>
            {user?.email ? (
              <>
                <li className="nav-item">
                  <button
                    className="nav-links"
                    style={{ backgroundColor: 'transparent', border: 'none', color: 'black' }}
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                </li>
                <li className="nav-item">
                  <IconButton
                    onClick={handleSearchToggle}
                    sx={{ padding: 0 }}
                    aria-label="search"
                  >
                    <Search />
                  </IconButton>
                </li>
                <li className="nav-item user-icon">
                  <IconButton onClick={handleProfClick} size="large" sx={{ padding: 0 }}>
                    {/* {console.log('user in Navbar:', user?.profile_pic_url)} */}
                    <Avatar
                      src={user?.profile_pic_url}
                      sx={{ bgcolor: "#1976d2" }}>
                      {user?.profile_pic_url}
                    </Avatar>
                    {/* <Avatar
                     
                    // sx={{


                    //   bgcolor: '#9d55e6',
                    //   borderRadius: '8px',
                    //   width: { xs: 32, sm: 36, md: 40 },
                    //   height: { xs: 32, sm: 36, md: 40 },
                    //   fontSize: { xs: 14, sm: 16, md: 18 },
                    //   color: 'white',
                    //   fontWeight: 600,

                    // }}
                    // >
                      {/* {!user?.profile_pic_url && <Person />} */}

                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    PaperProps={{
                      style: { width: '200px' },
                    }}
                  >
                    <MenuItem onClick={handleClose}>
                      <NavLink
                        to={{ pathname: '/appointments', state: { user } }}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                        onClick={closeMobileMenu}
                      >
                        Upcoming Bookings
                      </NavLink>
                    </MenuItem>
                    <MenuItem onClick={handleClose}>
                      <NavLink
                        to={{ pathname: '/appointments', search: '?past=true', state: { user } }}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                        onClick={closeMobileMenu}
                      >
                        My Past Bookings
                      </NavLink>
                    </MenuItem>
                    <MenuItem onClick={handleClose}>
                      <NavLink
                        to={{ pathname: '/profile', state: { user } }}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                        onClick={closeMobileMenu}
                      >
                        Profile
                      </NavLink>
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={handleClose}>
                      <NavLink
                        to={{ pathname: '/favourites', state: { user } }}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                        onClick={closeMobileMenu}
                      >
                        Favorites
                      </NavLink>
                    </MenuItem>
                  </Menu>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <button
                    className="nav-links"
                    style={{ backgroundColor: 'transparent', border: 'none', color: 'black' }}
                    onClick={onOpenLoginModal}
                  >
                    Client Login
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className="nav-links"
                    style={{ backgroundColor: 'transparent', border: 'none', color: 'black' }}
                    onClick={onOpenSignupModal}
                  >
                    Client Signup
                  </button>
                </li>
                <li className="nav-item">
                  <IconButton
                    onClick={handleSearchToggle}
                    sx={{ padding: 0 }}
                    aria-label="search"
                  >
                    <Search />
                  </IconButton>
                </li>
              </>
            )}
          </ul>
        </div>
      </nav>

      {/* Login Modal */}


      <Dialog
        open={openLogin}
        onClose={onCloseLoginModal}
        PaperProps={{ sx: { width: '90%', maxWidth: '400px', p: 2 } }}>
        <DialogTitle variant="h5" fontWeight={600} textAlign="center" mb={2}>Client Login</DialogTitle>
        <DialogContent>

          <form onSubmit={handleSubmitLogin}>
            {/* Email */}
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={form.email}
              onChange={onUpdateField}
              onBlur={onBlurField}
              variant="outlined"
              margin="normal"
              error={errors.email.dirty && errors.email.error}
              helperText={
                errors.email.dirty && errors.email.error
                  ? errors.email.message
                  : ""
              }
            />

            {/* Password */}
            <TextField
              fullWidth
              label="Password"
              name="password"
              type={showPassword ? "text" : "password"}
              value={form.password}
              onChange={onUpdateField}
              onBlur={onBlurField}
              variant="outlined"
              margin="normal"
              error={errors.password.dirty && errors.password.error}
              helperText={
                errors.password.dirty && errors.password.error
                  ? errors.password.message
                  : ""
              }
              placeholder="Password (Min 6 chars)"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword((s) => !s)}
                      edge="end"
                      size="small"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* Forgot Password */}
            <Box textAlign="right" mt={1} mb={2}>
              <MuiLink
                component={Link}
                to="/ForgotPassword"
                onClick={onCloseLoginModal}
                underline="hover"
                sx={{ fontSize: 14 }}
              >
                Forgot Password?
              </MuiLink>
            </Box>

            {/* Login Button */}
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              sx={{ py: 1.2, borderRadius: 2, fontWeight: 600 }}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Login'}

            </Button>
          </form>
        </DialogContent>
      </Dialog >



      {/* Forgot Password Modal */}
      <Modal open={openForgot} onClose={onCloseForgotModal} center styles={{ modal: { width: '90%', maxWidth: '400px' } }}>
        <h5>Enter your Email</h5>
        <form onSubmit={handleSubmitForgotPassword}>
          <label className="w-100 px-2">
            <input
              className="form-control"
              placeholder="Email"
              type="text"
              name="forgotEmail"
              value={forgotEmail}
              onChange={(event) => setForgotEmail(event.target.value)}
            />
          </label>
          <div className="w-100 px-2 mt-3">
            <input className="w-100 btn btn-primary" type="submit" value="Submit" />
          </div>
          <p className="mt-3">
            We shall send a Reset Password Link to this email if it is valid. After you receive the reset link, click{' '}
            <Link to="/PasswordReset" onClick={onCloseForgotModal}>
              here
            </Link>{' '}
            to Reset Password.
          </p>
        </form>
      </Modal>

      {/* Signup Modal */}
      <Dialog
        open={openSignup} onClose={onCloseSignupModal}
        PaperProps={{ sx: { width: '90%', maxWidth: '400px', p: 2 } }}>
        <DialogTitle variant="h5" fontWeight={600} textAlign="center" mb={2}>Client Signup</DialogTitle>
        <DialogContent>

          <form onSubmit={handleSubmitSignup}>
            {/* Email */}
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={form.email}
              onChange={onUpdateField}
              onBlur={onBlurField}
              variant="outlined"
              margin="dense"
              error={errors.email.dirty && errors.email.error}
              helperText={
                errors.email.dirty && errors.email.error
                  ? errors.email.message
                  : ""
              }
            />

            {/* Password */}
            <TextField
              fullWidth
              label="Password"
              name="password"
              type={showPassword ? "text" : "password"}
              value={form.password}
              onChange={onUpdateField}
              onBlur={onBlurField}
              variant="outlined"
              margin="dense"
              placeholder="Password (Min 6 chars)"

            />

            {/* Confirm Password */}
            <TextField
              fullWidth
              label="Confirm Password"
              name="confirmPassword"
              type={showPassword ? "text" : "password"}
              value={form.confirmPassword}
              onChange={onUpdateField}
              onBlur={onBlurField}
              variant="outlined"
              margin="dense"
              placeholder="Confirm Password (Min 6 chars)"

            />




            {/* First name */}
            <TextField
              fullWidth
              label="First Name"
              name="firstName"
              // type={showPassword ? "text" : "password"}
              value={form.firstName}
              onChange={onUpdateField}
              onBlur={onBlurField}
              variant="outlined"
              margin="dense"
              placeholder="First Name"
              error={errors.firstName.dirty && errors.firstName.error}
              helperText={
                errors.firstName.dirty && errors.firstName.error
                  ? errors.firstName.message
                  : ""
              }

            />

            {/* Last Name */}
            <TextField
              fullWidth
              label="Last Name"
              name="lastName"
              value={form.lastName}
              onChange={onUpdateField}
              onBlur={onBlurField}
              variant="outlined"
              margin="dense"
              placeholder="Last Name"
              error={errors.lastName.dirty && errors.lastName.error}
              helperText={
                errors.lastName.dirty && errors.lastName.error
                  ? errors.lastName.message
                  : ""
              }
            />


            <FormControl fullWidth margin="normal"
              error={errors.gender.dirty && errors.gender.error}>
              <InputLabel>Gender</InputLabel>
              <Select name="gender" value={form.gender} onChange={onUpdateField} onBlur={onBlurField} label="Gender">
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="0">Female</MenuItem>
                <MenuItem value="1">Male</MenuItem>
              </Select>
              {signupErrors.gender && <Typography color="error">{signupErrors.gender}</Typography>}
            </FormControl>

            <TextField
              fullWidth
              label="Date of Birth"
              name="dob"
              type="date"
              value={form.dob}
              onChange={onUpdateField}
              onBlur={onBlurField}
              error={errors.dob.dirty && errors.dob.error}
              helperText={
                errors.dob.dirty && errors.dob.error
                  ? errors.dob.message
                  : ""
              }
              margin="dense"
              InputLabelProps={{ shrink: true }}
            />
            {/* Last Name */}
            <TextField
              fullWidth
              label="Mobile"
              name="mobile"
              type="tel"
              value={form.mobile}
              onChange={onUpdateField}
              onBlur={onBlurField}
              error={errors.mobile.dirty && errors.mobile.error}
              helperText={
                errors.mobile.dirty && errors.mobile.error
                  ? errors.mobile.message
                  : ""
              }
              margin="dense"
            />

            <Typography variant="subtitle2" mt={2}>Profile Picture(Optional)</Typography>

            <Button
              variant="outlined"
              component="label"
              fullWidth
              sx={{ mt: 1 }}
            >
              Upload Profile Photo
              <input
                hidden
                accept="image/*"
                type="file"
                onChange={handleProfilePicChange}
              />
            </Button>

            {profilePicPreview && (
              <Box mt={2} display="flex" justifyContent="center">
                <img
                  src={profilePicPreview}
                  alt="Preview"
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
              </Box>
            )}

            <FormControlLabel
              control={
                <Checkbox
                  checked={acceptedTerms} // boolean (fixes your prop warning)
                  onChange={(e) => {
                    setAcceptedTerms(e.target.checked);
                    setSignupErrors((s) => ({ ...s, terms: undefined }));
                  }}
                />
              }
              label={
                <Typography variant="body2">
                  I accept the{' '}
                  <Link to="/ClientsTerms" style={{ color: '#1976d2', textDecoration: 'none' }} onClick={onCloseSignupModal}>
                    Terms & Conditions
                  </Link>
                </Typography>
              }
            />
            {signupErrors.terms && <Typography color="error" variant="caption" display="block">{signupErrors.terms}</Typography>}

            {/* Signup Button */}
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ mt: 2, backgroundColor: '#9d55e6' }}
              disabled={!acceptedTerms} // disable when terms not accepted
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Signup'}

            </Button>
          </form>
        </DialogContent>
      </Dialog >


    </IconContext.Provider >
  );
};

export default Navbar;
